export const SvgUnlockDisCancel = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="20" height="20" rx="10" fill="#FA4B4B" />
			<path
				d="M13.6997 6.87175L13.1734 6.3517C13.031 6.20929 12.7957 6.20929 12.6471 6.3517L10.0218 8.97698L7.34697 6.30217C7.20449 6.15969 6.9692 6.15969 6.82066 6.30217L6.29436 6.82847C6.15188 6.97089 6.15188 7.20618 6.29436 7.35478L8.96303 10.0235L6.34389 12.655C6.20148 12.7974 6.20148 13.0327 6.34389 13.1813L6.8702 13.7076C7.01261 13.85 7.2479 13.85 7.3965 13.7076L10.0218 11.0823L12.6471 13.7076C12.7895 13.85 13.0248 13.85 13.1734 13.7076L13.6997 13.1813C13.8421 13.0389 13.8421 12.8036 13.6997 12.655L11.0682 10.0297L13.6935 7.40438C13.8421 7.25565 13.8421 7.02036 13.6997 6.87175Z"
				fill="white"
			/>
		</svg>
	);
};
